import { render, staticRenderFns } from "./EnzymeSquad.vue?vue&type=template&id=49c5a2d8&scoped=true"
import script from "./EnzymeSquad.vue?vue&type=script&lang=js"
export * from "./EnzymeSquad.vue?vue&type=script&lang=js"
import style0 from "./EnzymeSquad.vue?vue&type=style&index=0&id=49c5a2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5a2d8",
  null
  
)

export default component.exports